import { c as _c } from "react/compiler-runtime";
import type React from 'react';
export const Required: React.FC = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <span className="ml-1 text-red-500">*</span>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};